import axios from '@/utils/axios'
const GetSettings = async () => {
  const {data} = await axios.get(process.env.NEXT_PUBLIC_API_URL + '/settings')
  return data
}
export {GetSettings}
